import React from 'react';
import RicercaSanzioneService from "./ricercaSanzioneService";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { URL,EASY_KEY } from './worldline.config';
import { toast, ToastContainer } from 'react-toastify';
import logo from './logoLCC.png';
import LoadSpinner from '../../common/spinner/loadSpinner';

class RicercaSanzioneR extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
          loading: true,
          sanzioni: [],
          sanzione: "",
          cercaSanzione: "",
          sanzioneTrovata: false,
          captcha:"",
          loadingButton:false,
          formData: {
            page:"",
            importo:"",
            valuta:"",
            idNegozio:"",
            numOrd:"",
            urlDone:"",
            urlBack:"",
            urlMS:"",
            tContab:"",
            tAutor:"",
            mac:""
          }
        };
        this.form = React.createRef();

        this.ricercaSanzioneService = new RicercaSanzioneService();
      }

      componentDidMount() {
        loadCaptchaEnginge(6);
        const params = new URLSearchParams(this.props.location.search);
        const id = params.get("id");
        if(id!== null){
          this.setState({cercaSanzione: id});
        }
    
        // this.ricercaSanzioneService = new RicercaSanzioneService();
        // this.ricercaSanzioneService.getSanzioni(id, this.sanzione.bind(this));
      }

      onChangeCercaSanzione(event) {
        this.state.cercaSanzione = event.target.value;
        this.setState({ cercaSanzione: this.state.cercaSanzione });
      }

      onChangeCaptchaInput(event){
        this.state.captcha = event.target.value;
        this.setState({captcha:this.state.captcha});
      }

    //   sanzione(result) {
    //     this.setState({ sanzioni: result });
    //   }

      cercaSanzione() {
        if(validateCaptcha(this.state.captcha,true)){
            this.setState({ sanzione: "" });

            this.ricercaSanzioneService.searchSanzione(
              (result) => {
                this.setState({ sanzione: result.data });
                
                this.setState({cercaSanzione:""})
                
                document.getElementById("sanzioneTrovata").scrollIntoView()

              },
              this.state.cercaSanzione,
            );
            validateCaptcha("",true);
        }else{
          toast.error(`Captcha Errato`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }

        this.setState({captcha:""});

        if (this.state.sanzione === "") {
          this.setState({ sanzioneTrovata: true });
        } else {
          this.setState({ sanzioneTrovata: false });
        }
      }
       pagaSanzione(importo) {
        this.setState({loadingButton:true})
        this.ricercaSanzioneService.pagaSanzione(this.state.sanzione.numeroSanzione,importo,(result) => {
          console.log(result.data)
          if (result.status === 200 && result.data !== "") {
            this.setState({formData:JSON.parse(JSON.stringify(result.data))})
            this.pagaSanzioneRedirect()
          }else{
            this.setState({loadingButton:false})
            toast.error('Errore riprova piu tardi', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          }
        },(idSanzione)=>{
          this.setState({loadingButton:false})
          toast.error(`Errore n. ${idSanzione} riprova piu tardi`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        });
       }

       pagaSanzioneRedirect(){
        this.form.current.submit()
       }

      render(){
        const dataRilascio = new Date(this.state.sanzione.dataEmissione);
            var data =
            dataRilascio.toLocaleDateString("it-IT")
        return(
            <div className='container-fluid ' style={{minHeight: "80vh"}}>
              <div>
              <form ref={this.form} hidden action=" https://acquistionline.poste.it/poste/pagamenti/main" method="POST">
                    <input type="hidden" name="PAGE" value={this.state.formData.page}/>
                    <input type="hidden" name="IMPORTO" value={this.state.formData.importo}/>
                    <input type="hidden" name="VALUTA" value={this.state.formData.valuta}/>
                    <input type="hidden" name="IDNEGOZIO" value={this.state.formData.idNegozio}/>
                    <input type="hidden" name="NUMORD" value={this.state.formData.numOrd}/>
                    <input type="hidden" name="URLDONE"
                    value={this.state.formData.urlDone}/>
                    <input type="hidden" name="URLBACK"
                    value={this.state.formData.urlBack}/>
                    <input type="hidden" name="URLMS"
                    value={this.state.formData.urlMS}/>
                    <input type="hidden" name="TCONTAB" value={this.state.formData.tContab}/>
                    <input type="hidden" name="TAUTOR" value={this.state.formData.tAutor}/>
                    <input type="hidden" name="MAC" value={this.state.formData.mac}/>
                  </form>
              </div>
              <ToastContainer/>
              <div className='row d-flex flex-md-row flex-column-reverse justify-content-between justify-content-md-center align-items-center text-center text-lg-start pt-3 pl-lg-5'>
              <h2 className='col-12 col-md-5'>RICERCA E PAGA UNA SANZIONE</h2>
                    <img className='col-5 col-md-5' src={logo} style={{height:"50px", width:"150px"}} alt='logo Linee Lecco'/>
                </div>
                <div className='row d-flex flex-column flex-lg-row p-lg-5 p-lg-0 p-4 gap-4 gap-lg-0 align-items-center justify-content-center'>
                <div className='col-10 mr-lg-5 col-lg-6 d-flex flex-column gap-5 align-items-center card h-100'>
                        <h3 className='pt-4'>Ricerca la tua sanzione</h3>
                        <div className='d-flex flex-column flex-lg-row gap-3'>
                            <label> N° Identificativo</label>
                            <input id="cercaSanzioneInput" type="text" value={this.state.cercaSanzione} onChange={this.onChangeCercaSanzione.bind(this)}
                            />
                        </div>
                        <div className='d-flex flex-column  gap-3 w-50 justify-content-center align-items-center'>
                            <LoadCanvasTemplate />
                            <input type="text" value={this.state.captcha} onChange={this.onChangeCaptchaInput.bind(this)}/>
                        </div>
                        <button
                            className="btn btn-primary mb-3"
                            onClick={this.cercaSanzione.bind(this)}
                            disabled={this.state.cercaSanzione.length < 5}>
                                CERCA
                                </button>
                    </div>
                    <div id='sanzioneTrovata' className='col-10 col-lg-4 d-flex flex-column justify-content-center ps-lg-5'>{this.state.sanzione === ""
                    ?<></>
                    :<div className='card d-flex flex-column py-3'>
                        <h5 className='card-title p-5 lh-lg'>N° Identificativo: <span className='fs-6'> {this.state.sanzione.numeroSanzione} </span></h5>
                        <div className='card-body'>
                            <h6 class="card-subtitle mb-2 text-muted p-3">Data Emissione: {data !=="1/1/1970"? data : ""}</h6>
                            {this.state.sanzione.importoDaPagareDue > 0 && <h6 className='text-danger'>Attenzione, Scegli l'importo in valutazione dalla data di notifica</h6>}
                        </div>
                        <div className='d-flex justify-content-center p-0 m-2 justify-content-lg-center gap-2'>
                        {this.state.sanzione.importoDaPagareDue > 0
                        ?<button
                            className="btn btn-primary text-center w-50"
                            onClick={()=> this.pagaSanzione(this.state.sanzione.importoDaPagareDue)}
                            disabled={!this.state.sanzione.importoDaPagareDue > 0 || this.state.loadingButton}
                        >
                             {this.state.loadingButton ? <LoadSpinner/>:(this.state.sanzione.importoDaPagareDue / 100).toFixed(2) + " €"}
                        </button>
                        :""}
                        <button
                            className="btn btn-primary text-center w-50"
                            onClick={()=> this.pagaSanzione(this.state.sanzione.importoDaPagare)}
                            disabled={!this.state.sanzione.importoDaPagare > 0 || this.state.loadingButton}
                        >
                             {this.state.loadingButton ? <LoadSpinner/>:(this.state.sanzione.importoDaPagare / 100).toFixed(2) + " €"}
                        </button>
                        </div>
                    </div>}

                    </div>
                </div>
                <p className='text-center' style={{fontSize:"0.7rem"}}>Linee Lecco S.p.a. P.zza Bione, 15, 23900 Lecco (LC) | Italia tel.: +39 0341.359911</p>
                <p className='text-center' style={{fontSize:"0.7rem"}}> C.F. 92004770134 | P.IVA 02320500131  - lineelecco@pec.it</p>
            </div>
        )
      }

}

export default RicercaSanzioneR;